<div class="padding">
    <!-- Page Header -->
    <h1 class="margin-top-bottom-25">{{ 'contactUs.contactUs' | transloco }}</h1>
    <p class="intro-text padding-bottom-25">
    {{ 'contactUs.weReHereToAssistYou' | transloco }}
    </p>

    <!-- Contact Cards in a Responsive Flex Layout -->
    <div class="flex-container flex-wrap" [@fadeIn]>
        <mat-card class="document-card mat-elevation-z5">
            <!-- Thumbnail Image -->
            <mat-icon class="icon-display margin-top-bottom-25 margin-sides-25">support_agent</mat-icon>
            
            <!-- Card Content -->
            <mat-card-content class="padding">
                <mat-card-title class="card-title">{{ 'contactUs.operationalClientSupport' | transloco }}</mat-card-title>
                <mat-card-subtitle>{{ 'contactUs.forAssistanceWithOurServicesOr' | transloco }}</mat-card-subtitle>

                <p class="flex-container">
                    <strong class="flex-item">{{ 'common.labels.email2' | transloco }}</strong>
                    <a [href]="supportLink" class="flex-item-4">support&#64;reghub.ca</a>
                </p>
                <p class="flex-container">
                    <strong class="flex-item">{{ 'contactUs.phone' | transloco }}</strong>
                    <a [href]="supportPhone" class="flex-item-4">1 (888) 508-0608</a>
                </p>
                
            </mat-card-content>

            <!-- Card Actions -->
            <mat-card-actions class="card-actions">
                <mat-card-footer class="margin-left-15">
                    <h5>{{ 'contactUs.availableMondayFriday900Am' | transloco }}</h5>
                </mat-card-footer>
              </mat-card-actions>
        </mat-card>

        <mat-card class="document-card mat-elevation-z5">
            <!-- Thumbnail Image -->
            <mat-icon class="icon-display margin-top-bottom-25 margin-sides-25">attach_money</mat-icon>
            
            <!-- Card Content -->
            <mat-card-content class="padding">
                <mat-card-title class="card-title">{{ 'contactUs.billingSupport' | transloco }}</mat-card-title>
                <mat-card-subtitle>{{ 'contactUs.forBillingInquiriesOrAssistanceWith' | transloco }}</mat-card-subtitle>

                <p class="flex-container">
                    <strong class="flex-item">{{ 'common.labels.email2' | transloco }}</strong>
                    <a [href]="supportLink" class="flex-item-4">billing&#64;reghub.ca</a>
                </p>

                <p class="flex-container">
                    <strong class="flex-item"></strong>
                    <a [href]="" class="flex-item-4"></a>
                </p>
            </mat-card-content>
            <span class="spacer"></span>
            <!-- Card Actions -->
            <mat-card-actions class="card-actions">
                <mat-card-footer class="margin-left-15">
                    <h5>{{ 'contactUs.availableMondayFriday900Am' | transloco }}</h5>
                </mat-card-footer>
              </mat-card-actions>
        </mat-card>
    </div>
</div>